import { useMutation } from '@tanstack/react-query';

import { reportingLeDataSessionSteerPath } from '~/consts/reportingLeDataApi';

import { json_headers, request } from '~/services/common';

import { encodeRequestBody } from '~/utils/encodeRequestBody';
import { resolveReportingLeDataUrl } from '~/utils/resolveReportingLeDataUrl';

type SteerSessionInput = {
  sessionId: string;
  text: string;
};

/**
 * POST `/api/reporting/le-data/sessions/:sessionId/steer` with `{ text }`.
 * 202 when the active run accepted the steer; the server responds 409 when there is no active run.
 */
export function useSteerReportingLeDataSession() {
  return useMutation({
    mutationFn: async ({ sessionId, text }: SteerSessionInput) => {
      const url = resolveReportingLeDataUrl(reportingLeDataSessionSteerPath(sessionId));
      await request(url, {
        method: 'POST',
        headers: json_headers,
        body: JSON.stringify(encodeRequestBody({ text })),
        ignoreResponse: true,
      });
    },
  });
}
